import moment, { lang } from "moment";
// import crypto from "crypto-browserify";

// Sort Table Rows

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
};

export const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const generateSortedRowInformation = (rowData, comparator) => {
  if (Object.prototype.toString.call(rowData) === "[object Array]") {
    const stablizedRowInformation = rowData.map((element, index) => [
      element,
      index,
    ]);
    stablizedRowInformation.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stablizedRowInformation.map((data) => data[0]);
  }
};

// format date

export const formattedDate = (date, type) => {
  const formatDate =
    type === "activeToDate"
      ? date
        ? moment(date).utc().format("DD/MM/YYYY")
        : null
      : moment(date).utc().format("DD/MM/YYYY");

  return formatDate;
};

// generate base 64 encoded URL

// const base64URLEncode = (str) =>
//   str
//     .toString("base64")
//     .replace(/\+/g, "-")
//     .replace(/\//g, "_")
//     .replace(/=/g, "");

// generate pkce challenge sha code

// export const generateChallenge = () => {
//   const verifier = base64URLEncode(crypto.randomBytes(32));
//   const sha256 = (buffer) =>
//     crypto.createHash("sha256").update(buffer).digest();
//   return base64URLEncode(sha256(verifier));
// };

// format user groups

export const formattedUserGroups = (str) =>
  str
    ? str.startsWith("[")
      ? str.slice(1, str.length - 1).split(",")
      : str.split(",")
    : "";

export const getCookie = (name) => {
  const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return value ? value[2] : null;
};
// set Cookies
export const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};
// language detection
export const detectLanguage = () => {
  let language = "en";
  const langCookie = getCookie("lang");
  if (langCookie) {
    language = langCookie;
  } else {
    language =
      window.navigator.userLanguage || window.navigator.language.split("-")[0];
  }
  setCookie("lang", language, 30);
  return language;
};

export const getCountrySk = () => {
  return getCookie("CountrySk");
}

export const getMonthAndYearFromDate = (date, locale = 'en') => {
  const langs = {
    en: {
      "January": "January",
      "February": "February",
      "March": "March",
      "April": "April",
      "May": "May",
      "June": "June",
      "July": "July",
      "August": "August",
      "September": "September",
      "October": "October",
      "November": "November",
      "December": "December"
    },
    es: {
      "January": "enero",
      "February": "Febrero",
      "March": "Marzo",
      "April": "Abril",
      "May": "Mayo",
      "June": "Junio",
      "July": "Julio",
      "August": "Agosto",
      "September": "Septiembre",
      "October": "Octubre",
      "November": "Noviembre",
      "December": "Diciembre"
    }
  }
  const month = (date) ? moment(date).format("MMMM") : "";
  const year = (date) ? moment(date).format("YYYY") : "";
  return (month) ? `${langs[locale][month]} ${year}` : '';
}

export const formatName = (input) => {
  // Remove any unnecessary characters and trim whitespace
  const cleanedInput = input.replace(/\([^()]+\)/g, "").trim();

  // Split the name into parts
  const [FirstName, LastName] = cleanedInput.split(', ').reverse();

  const FullName = (LastName) ? `${FirstName} ${LastName}` : FirstName;

  // Return the formatted name as an object
  return {
    FullName,
    FirstName,
    LastName
  };
}

export const checkStatus = (data, year
  ) => {
  const output = {
    jan: null,
    feb: null,
    mar: null,
    apr: null,
    may: null,
    jun: null,
    jul: null,
    aug: null,
    sep: null,
    oct: null,
    nov: null,
    dec: null
  };
  
  const count = {};

  data?.forEach(row => {
    
    Object.keys(output).forEach(month => {
      if (row[month] !== null) {
        if (!count[month]) {
          count[month] = 1;
        } else {
          count[month] = count[month] + 1; 
        }
      }
    })
  });
  
  for (const month in output) {
      if (count[month]) {
          output[month] = (count[month] === data.length) ? "Closed" : "Opened"
      }
  }

  output.id = 1;
  output.year = year;
  output.name = "";

  return [output];
}